import { api } from "api/api";
import { AxiosError } from "axios";
import Acao from "model/administracao/cadastro/Acao";
import Modulo from "model/administracao/cadastro/Modulo";
import Perfil from "model/administracao/cadastro/Perfil";
import ItemDashboard from "model/dashboard/ItemDashboard";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";

class PerfilService implements BaseServiceCadastros<Perfil> {

    pesquisar(page: Pageable, filter?: DataTableFilterMeta|null, idConta?: number | null) {
        return new Promise<Page>((resolve, reject): void => {

            let url = `/perfil/pesquisar`;
            if (idConta) {
                url += `?idConta=${idConta}`;
            }

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number, idConta?: number | null) {
        return new Promise<Perfil>((resolve, reject): void => {
            let url = `/perfil/consultar/${id}`;
            if (idConta) {
                url += `?idConta=${idConta}`;
            }
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    modulosAcoes(idConta?: number|null) {
        return new Promise<Array<Modulo>>((resolve, reject): void => {
            let url = `/perfil/modulos/acoes`;
            if (idConta) {
                url += `?idConta=${idConta}`;
            }
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(perfil: Perfil, idConta?: number | null) {
        return new Promise<Perfil>((resolve, reject): void => {
            let url = `/perfil/incluir`;
            if (idConta) {
                url += `?idConta=${idConta}`;
            }
            api
                .post(url, JSON.stringify(perfil))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(perfil: Perfil, idConta?: number | null) {
        return new Promise<Perfil>((resolve, reject): void => {
            let url = `/perfil/editar`;
            if (idConta) {
                url += `?idConta=${idConta}`;
            }
            api
                .put(url, JSON.stringify(perfil))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number, idConta?: number | null) {
        return new Promise<void>((resolve, reject): void => {
            let url = `/perfil/excluir/${id}`;
            if (idConta) {
                url += `?idConta=${idConta}`;
            }
            api
                .delete(url)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    itensDashboard(idConta?: number | null) {
        return new Promise<Array<ItemDashboard>>((resolve, reject): void => {
            let url = `/perfil/itensDashboard`;
            if (idConta) {
                url += `?idConta=${idConta}`;
            }
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}

export default PerfilService;
